import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import './spinner.scss';

export function Spinner({ show, inline }) {
	if (!show) return null;
	return <div className={classnames('ph-spinner', { inline })} />;
}

Spinner.propTypes = {
	show: PropTypes.bool,
	inline: PropTypes.bool,
};

export default Spinner;
